import api from "./api";

// Türkçe karakterleri İngilizce karşılıklarına çeviren fonksiyon
const turkishToEnglish = (text) => {
  const turkishChars = {
    'ç': 'c', 'Ç': 'C',
    'ğ': 'g', 'Ğ': 'G', 
    'ı': 'i', 'I': 'I',
    'İ': 'I', 'i': 'i',
    'ö': 'o', 'Ö': 'O',
    'ş': 's', 'Ş': 'S',
    'ü': 'u', 'Ü': 'U'
  };
  
  return text.replace(/[çÇğĞıIİiöÖşŞüÜ]/g, function(match) {
    return turkishChars[match] || match;
  });
};

// Slug oluşturan fonksiyon
export const createSlug = (text) => {
  if (!text) return '';
  return turkishToEnglish(text)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')           // Boşlukları tire ile değiştir
    .replace(/[^a-z0-9-]/g, '')     // Sadece harf, rakam ve tire bırak
    .replace(/-+/g, '-')            // Çoklu tireleri tek tire yap
    .replace(/^-|-$/g, '');         // Başta ve sonda tire varsa kaldır
};

export const getCategories = async () => {
  try {
    const res = await api.get("/categories/");
    // API'den gelen _id'yi id'ye dönüştür
    const normalizedData = res.data.map(category => {
      const normalized = {
        ...category,
        id: category._id || category.id, // MongoDB'nin _id'sini id'ye map et, fallback to existing id
        name: category.title // API'de title olarak geliyor, name olarak da kullanılabilir
      };
      
      // Eğer id hala undefined ise, slug kullan
      if (!normalized.id) {
        normalized.id = category.slug;
        console.warn(`No _id found for category ${category.slug}, using slug as id`);
      }
      
      return normalized;
    });
    return normalizedData;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const getCategoryBySlug = async (slug) => {
  try {
    const res = await api.get(`/categories/${slug}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching category:", error);
    throw error;
  }
};

export const createCategory = async (data) => {
  try {
    
    
    // data.title veya data.name'i kontrol et
    const titleData = data.title || data.name;
    if (!titleData || !titleData.tr) {
      throw new Error("Title data is missing or invalid");
    }
    
    // Multi-language slug generation
    const slugData = data.slug || {
      tr: createSlug(titleData.tr),
      en: createSlug(titleData.en || titleData.tr),
      es: createSlug(titleData.es || titleData.tr)
    };
    
    const formattedData = {
      slug: slugData,
      title: titleData,
      description: data.description,
      image: data.image || "string",
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    const res = await api.post("/categories/", formattedData);
    return res.data;
  } catch (error) {
    console.error("Error creating category:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const updateCategory = async (id, data) => {
  try {
    
    
    // data.title veya data.name'i kontrol et
    const titleData = data.title || data.name;
    if (!titleData || !titleData.tr) {
      throw new Error("Title data is missing or invalid");
    }
    
    // Multi-language slug generation
    const slugData = data.slug || {
      tr: createSlug(titleData.tr),
      en: createSlug(titleData.en || titleData.tr),
      es: createSlug(titleData.es || titleData.tr)
    };
    
   
    const formattedData = {
      slug: slugData,
      title: titleData,
      description: data.description,
      image: data.image || "string",
      updatedAt: new Date().toISOString()
    };
    
    // Order varsa ekle
    if (data.order !== undefined && data.order !== null) {
      formattedData.order = parseInt(data.order, 10);
    }
    
    const res = await api.put(`/categories/${id}`, formattedData);
    return res.data;
  } catch (error) {
    console.error("Error updating category:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const deleteCategory = async (id) => {
  try {
    const res = await api.delete(`/categories/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting category:", error);
    throw error;
  }
};

// Sadece order alanını güncelle
export const updateCategoryOrder = async (id, order) => {
  try {
    console.log("→ Sending order update:", { id, order });
    
    // Order değerini integer olarak gönder
    const res = await api.put(`/categories/${id}`, {
      order: parseInt(order, 10)
    });
    
    console.log("← Received response:", res.data);
    return res.data;
  } catch (error) {
    console.error("✗ Order update failed:", error.response?.data || error.message);
    throw error;
  }
};

export const uploadCategoryImage = async (id, file) => {
  try {
 
    
    const formData = new FormData();
    formData.append("image", file);
    
    const res = await api.post(`/categories/${id}/image`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    console.error("=== ERROR UPLOADING CATEGORY IMAGE ===");
    console.error("Error:", error.message);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};
